/**
 * FontScale — Centralized typographic scale for the Woodchuck arcade game.
 *
 * "Press Start 2P" pixel font on 800×600 canvas.
 * 8px absolute minimum for legibility.
 */

// Font family string for Phaser text style objects
const FONT = '"Press Start 2P"';

// Raw font family for Canvas2D ctx.font usage
const FONT_RAW = "Press Start 2P";

// Named font size scale (pixels)
const FONT_SIZE = Object.freeze({
  DISPLAY: 32, // Full-screen takeover: GAME OVER, STAGE CLEAR, ROBOT DETECTED
  TITLE: 24, // Scene hero titles: WOODCHUCK, HIGH SCORES, EPOCH COMPLETE
  HEADING: 16, // Section headers, stat values, combo counter, primary buttons
  SUBHEADING: 12, // Secondary headers, action buttons, medium emphasis
  BODY: 12, // Standard UI text, HUD labels, table rows, nav buttons
  CAPTION: 10, // Supporting info, metadata, column headers, descriptions
  LABEL: 10, // De-emphasized text (differentiated by color, not size)
});

// Build a Phaser text style object
function fontStyle(size, fill, extras) {
  return {
    fontFamily: FONT,
    fontSize: `${size}px`,
    fill,
    ...extras,
  };
}

export { FONT, FONT_RAW, FONT_SIZE, fontStyle };
